import { Box, TableCellProps, Tooltip, Typography, useTheme } from "@mui/material"
import { Win } from "../../../interfaces/dtos/win"
import { RPMTableHeaderCell } from "../../shared/table/RPMTableHeaderCell"
import { JSX } from 'react';
import dayjs from "dayjs";

interface ScheduleWinRunnerHeadingProps {
    eventWin: Win,
    columnNo: number,
    getTableCellProps: (eventWin: Win, index: number, forHeader?: boolean) => TableCellProps
}

export const ScheduleWinRunnerHeading = ({
    eventWin, columnNo, getTableCellProps
}: ScheduleWinRunnerHeadingProps) => {

    const theme = useTheme();

    const getHeadingText = (eventWin: Win) => {
        const type = getHeadingPriceType(eventWin);

        const tooltip = getHeadingTooltip(eventWin);
        const suspendedDesc = getHeadingSuspendedDesc(eventWin);        
        const time = eventWin.timestamp ? dayjs(eventWin.timestamp).format('HH:mm:ss') : "";
        return (
            <Tooltip id='header-tooltip' title={tooltip}>
                <Box sx={{ cursor: 'default' }}>
                    <Typography variant="inherit"
                        sx={{
                            pb: '0px',
                            borderBottom: `3px solid ${eventWin.calculated?.isDistributed ? theme.palette.success.main : theme.palette.error.main}`
                        }}>
                        {type}
                    </Typography>
                    {time}
                    {suspendedDesc}
                </Box>
            </Tooltip>
        )
    }

    const getHeadingTooltip = (eventWin: Win) => {
        let tooltip = eventWin.calculated?.isDistributed ? "" : getHeadingTooltipItem("Not distributed", eventWin.distributionDetails?.distributionReason);
        if (eventWin.calculated?.isRejected) {
            tooltip = getHeadingTooltipItem("Rejected", eventWin.rejectionDetails?.rejectedReason, tooltip);
        } else if (eventWin.calculated?.isSuspended) {
            tooltip = getHeadingTooltipItem("Suspended", eventWin.suspensionDetails?.suspendedReason, tooltip);
        }
        return tooltip;
    }

    const getHeadingTooltipItem = (heading: string, item?: string, previousTooltip?: string | JSX.Element) => {
        return (
            <>
                {previousTooltip && <>{previousTooltip}<br /><br /></>}
                <Box sx={{ display: 'inline', color: 'rgb(200, 255, 255)', fontWeight: 'bold' }}>{heading} reason:</Box><br />
                <Box sx={{ display: 'inline', fontWeight: 'normal' }}>{item}</Box>
            </>
        )
    }

    const getHeadingSuspendedDesc = (eventWin: Win) => {
        let susppendDesc = undefined;
        if (eventWin.calculated?.isRejected) {
            susppendDesc = "Rejected";
        } else if (eventWin.calculated?.isSuspended) {
            susppendDesc = "Suspended";
        }

        return susppendDesc ? <Box sx={{ cursor: 'default' }}>{susppendDesc}</Box> : <></>;
    }

    const getHeadingPriceType = (eventWin: Win) => {
        if (eventWin.calculated?.isEarlyPrice) {
            return "E";
        } else if (eventWin.calculated?.isBoardPrice) {
            return "B";
        } else if (eventWin.calculated?.isIgnorePrice) {
            return "Ignore";
        } else {
            return "U";
        }
    }

    return (
        <RPMTableHeaderCell
            key={eventWin.timestamp}
            id={`runner-header-${eventWin.version}`}
            {...getTableCellProps(eventWin, columnNo, true)}
        >
            {getHeadingText(eventWin)}
        </RPMTableHeaderCell>
    )
}
